import { addDays } from 'date-fns';
import { ESubscriptionType, ICompany, ISubscription } from '@types';
import { toArray } from './array';

function isTrialExpired(created: Date) {
  const expiration = addDays(created, 14);
  const expired = expiration < new Date();
  return { expired, expiration };
}

export function getTariff(c: ICompany, hasPaymentIntegrations?: boolean): ISubscription {
  const tariff = c.subscriptions?.map(s => {
    s.nextPayment ??= { year: 0, month: 0, day: 0 };
    return s;
  }).sort((a, b) => {
    if (a.nextPayment.year !== b.nextPayment.year) return b.nextPayment.year - a.nextPayment.year;
    if (a.nextPayment.month !== b.nextPayment.month) return b.nextPayment.month - a.nextPayment.month;
    return b.nextPayment.day - a.nextPayment.day;
  })[0];

  if (tariff && tariff.nextPayment) {
    tariff._expiration = new Date(tariff.nextPayment.year, tariff.nextPayment.month - 1, tariff.nextPayment.day);
    tariff._active = new Date() < tariff._expiration;
    if (tariff._active) return tariff;
  }

  const { expired, expiration } = isTrialExpired(c.created);
  if (!expired) return { type: ESubscriptionType.TARIFF_TRIAL, _active: true, _expiration: expiration };

  if (hasPaymentIntegrations) return { type: ESubscriptionType.TARIFF_START_FREE, _active: true };

  return tariff;
}

export function checkCompanyTariff(c: ICompany, tariff: ESubscriptionType | ESubscriptionType[]) {
  return c?._tariff?._active && toArray(tariff).includes(c._tariff.type)
}

export function hasCompanyAccessToPro(c: ICompany) {
  return checkCompanyTariff(c, [ESubscriptionType.TARIFF_TRIAL, ESubscriptionType.TARIFF_PRO]);
}

export function hasCompanyTariff(c: ICompany) {
  return checkCompanyTariff(c, [ESubscriptionType.TARIFF_START_FREE, ESubscriptionType.TARIFF_START, ESubscriptionType.TARIFF_PRO]);
}

export function hasCompanyPaidTariff(c: ICompany) {
  return checkCompanyTariff(c, [ESubscriptionType.TARIFF_START, ESubscriptionType.TARIFF_PRO]);
}

export function hasCompanyAccessToPlatform(c: ICompany) {
  return c?._tariff?._active;
}

export const tariffLabel = {
  [ESubscriptionType.TARIFF_START]: 'Cue Start',
  [ESubscriptionType.TARIFF_PRO]: 'Cue Pro',
  [ESubscriptionType.TARIFF_TRIAL]: 'Cue Trial',
  [ESubscriptionType.TARIFF_START_FREE]: 'Cue Free',
};

export function getTariffLabel(tariff?: ESubscriptionType) {
  return tariffLabel[tariff] || tariff;
}

// function frequencyToMonths(v: ESubscriptionFrequency) {
//   switch (v) {
//     case ESubscriptionFrequency.MONTHLY: return 1;
//     case ESubscriptionFrequency.THREE_MONTHLY: return 3;
//     case ESubscriptionFrequency.SIX_MONTHLY: return 6;
//     case ESubscriptionFrequency.YEARLY: return 12;
//     default: return 0;
//   }
// }
